import { Component } from '@angular/core';

@Component({
    selector: 'app-workplace',
    templateUrl: './workplace.component.html',
    styleUrls: ['./workplace.component.scss'],
    standalone: false
})
export class WorkplaceComponent {

   public selectedSubcategories : number[] =[]
 
}
